import { render, staticRenderFns } from "./main-layout.component.vue?vue&type=template&id=4956e568"
import script from "./main-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./main-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./main-layout.component.vue?vue&type=style&index=0&id=4956e568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports